import * as React from "react";
const SvgMore = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 256, height: 256, style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("g", { id: "mid" }, /* @__PURE__ */ React.createElement("circle", { cx: 128, cy: 48, r: 24, style: {
  fill: "#757d84"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 128, cy: 128, r: 24, style: {
  fill: "#757d84"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 128, cy: 208, r: 24, style: {
  fill: "#757d84"
} }))));
export default SvgMore;
